/**
 * Returns the product flagged as primary by the BE (`isPrimary`), falling back to the first
 * product when none is flagged (or the list is empty/undefined).
 *
 * The generic is intentionally constrained to `object` rather than `{ isPrimary?: boolean }`:
 * the latter is a TypeScript "weak type" (all properties optional), which triggers weak-type
 * detection and rejects product shapes that don't declare `isPrimary` at all — e.g.
 * `RealEstatePropertyAssignmentProductsDTO` (property assignments). Constraining on `object`
 * accepts any product-like shape; those without the flag simply fall back to the first product.
 */
export function choosePrimaryProduct<T extends object>(products: T[] | undefined): T | undefined {
  return products?.find(product => 'isPrimary' in product && product.isPrimary) ?? products?.[0]
}
